<template>
  <v-container
    id="dashboard-view"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        xl="6"
        lg="12"
      >
        <material-card
          ref="salesGridRef"
          color="success"
          full-header
        >
          <template #heading>
            <div class="pl-4 pr-4 pt-1 pb-1 white--text">
              <div class="text-h3 font-weight-light">
                <v-col>
                  <v-row>
                    Sales Team Stats
                    <v-spacer />
                    <v-btn
                      v-if="selectedItems.length > 0"
                      class="ml-1 mr-3"
                      color="success"
                      depressed
                      small
                      @click="clearSelection"
                    >
                      Clear Selection
                      <v-icon class="ml-3">
                        mdi-filter-remove
                      </v-icon>
                    </v-btn>
                    <v-btn
                      color="white"
                      icon
                      small
                      @click="salesGridButtonClicked"
                    >
                      <v-icon>
                        mdi-axis-arrow
                      </v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              ref="SalesTeamGrid"
              item-key="SalesPerson"
              class="dataTable font-weight-bold"
              item-class="font-weight-black"
              :items-per-page="itemsPerPage"
              :headers="headers"
              :items="items"
              @click:row="tableClicked"
              @dblclick:row="rowDblClicked"
            >
              <template v-slot:item.TotalTradeNow="{ item }">
                {{ formatCurrency(item.TotalTradeNow) }}
              </template>
              <template v-slot:item.TradeVsLastYear="{ item }">
                <div
                  v-if="item.TradeVsLastYear > 0"
                  class="green--text"
                >
                  {{ formatCurrency(item.TradeVsLastYear) }}
                  ▲
                </div>
                <div
                  v-else-if="item.TradeVsLastYear < 0"
                  class="red--text"
                >
                  {{ formatCurrency(item.TradeVsLastYear) }}
                  ▼
                </div>
                <div v-else>
                  {{ formatCurrency(item.TradeVsLastYear) }}
                </div>
              </template>
              <template v-slot:item.TradePercentVsLastYear="{ item }">
                <div
                  v-if="item.TradePercentVsLastYear > 0"
                  class="green--text"
                >
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                  ▲
                </div>
                <div
                  v-else-if="item.TradePercentVsLastYear < 0"
                  class="red--text"
                >
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                  ▼
                </div>
                <div v-else>
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                </div>
              </template>
              <template v-slot:item.TotalMSFNow="{ item }">
                {{ formatNumber(item.TotalMSFNow) }}
              </template>
              <template v-slot:item.MsfVsLastYear="{ item }">
                <div
                  v-if="item.MsfVsLastYear > 0"
                  class="green--text"
                >
                  {{ formatNumber(item.MsfVsLastYear) }}
                  ▲
                </div>
                <div
                  v-else-if="item.MsfVsLastYear < 0"
                  class="red--text"
                >
                  {{ formatNumber(item.MsfVsLastYear) }}
                  ▼
                </div>
                <div v-else>
                  {{ formatNumber(item.TradeVsLastYear) }}
                </div>
              </template>
              <template v-slot:item.MsfPercentVsLastYear="{ item }">
                <div
                  v-if="item.MsfPercentVsLastYear > 0"
                  class="green--text"
                >
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                  ▲
                </div>
                <div
                  v-else-if="item.MsfPercentVsLastYear < 0"
                  class="red--text"
                >
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                  ▼
                </div>
                <div v-else>
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </material-card>
      </v-col>
      <v-col
        cols="12"
        xl="6"
        lg="12"
        md="12"
      >
        <v-row>
          <v-col cols="12">
            <material-card
              ref="salesGoalsRef"
              color="secondary"
              full-header
            >
              <template #heading>
                <div class="pl-4 pr-4 pt-1 pb-1 white--text">
                  <div class="text-h3 font-weight-light">
                    <v-col>
                      <v-row>
                        Sales Team Goals
                        <v-spacer />
                        <v-btn
                          color="white"
                          icon
                          small
                          @click="salesGoalsButtonClicked"
                        >
                          <v-icon>
                            mdi-axis-arrow
                          </v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </div>
                </div>
              </template>
              <v-card-text>
                <apexchart
                  type="line"
                  :height="graphHeight"
                  :options="threeAxisData.chartOptions"
                  :series="threeAxisData.series"
                />
              </v-card-text>
            </material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <material-card
              ref="salesTeamPieRef"
              color="secondary"
              full-header
            >
              <template #heading>
                <div class="pl-4 pr-4 pt-1 pb-1 white--text">
                  <div class="text-h3 font-weight-light">
                    <v-col>
                      <v-row>
                        Sales Team Total Trade
                        <v-spacer />
                        <v-btn
                          color="white"
                          icon
                          small
                          @click="salesPieButtonClicked"
                        >
                          <v-icon>
                            mdi-axis-arrow
                          </v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </div>
                </div>
              </template>
              <v-card-text>
                <apexchart
                  type="pie"
                  :height="pieHeight"
                  :options="pieData.chartOptions"
                  :series="pieData.series"
                />
              </v-card-text>
            </material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { salesTeamGoalsData, salesTeamSalesPieData } from '@/util/chartdata.js'
  import {
    formatNumber,
    formatCurrency,
    formatPercentage,
  } from '@/util/formatters.js'
  import { salesTeamStatsGridHeaders } from '../util/gridHeaders.js'
  import { serverUrl } from '../../auth_config.json'
  import { get, store } from 'vuex-pathify'
  import { updateMenuDrawer, updateScopes } from '../auth/authorization'

  export default {
    name: 'SalesTeamDashboardView',
    data: () => ({
      threeAxisData: { chartOptions: {}, series: [] },
      pieData: { chartOptions: {}, series: [] },
      graphHeight: 400,
      pieHeight: 500,
      salesTeam: [],
      selectedItems: [],
      headers: salesTeamStatsGridHeaders,
      items: [],
      stats: [],
      itemsPerPage: 15,
    }),
    computed: {
      ...get('user', ['dark']),
    },
    async created () {
      this.fetchSalesTeam().then(data => {
        this.items = data
        this.threeAxisData = salesTeamGoalsData(this.items, this.getTheme())
        this.pieData = salesTeamSalesPieData(
          this.getTopTenTrade(this.items),
          this.getTheme(),
        )
        updateMenuDrawer()
      })
    },
    methods: {
      async rowDblClicked (item, row) {
        await this.$store.dispatch('app/addSalesItem', { salesPerson: row.item.SalesPerson, userId: row.item.UserId })
        // this.$router.push({
        //   name: 'SalesPersonDashboard',
        //   params: {
        //     salesPerson: row.item.SalesPerson,
        //     salesUserId: row.item.UserId,
        //   },
        // })
      },
      salesGridButtonClicked () {
        const g = this.$refs.salesGridRef
        this.toggleMaxArea(g)
      },
      salesGoalsButtonClicked () {
        const g = this.$refs.salesGoalsRef
        if (this.toggleMaxArea(g)) {
          this.graphHeight = (window.innerHeight / 3) * 2
        } else {
          this.graphHeight = 400
        }
      },
      salesPieButtonClicked () {
        const g = this.$refs.salesTeamPieRef
        if (this.toggleMaxArea(g)) {
          this.pieHeight = (window.innerHeight / 4) * 3
        } else {
          this.pieHeight = 500
        }
      },
      tableClicked (_, row) {
        const rowNum = this.selectedItems.indexOf(row.item)
        if (rowNum === -1) {
          this.selectedItems.push(row.item)
          row.select(true)
        } else {
          this.selectedItems.splice(rowNum, 1)
          row.select(false)
        }
        this.threeAxisData = salesTeamGoalsData(
          [...this.selectedItems],
          this.getTheme(),
        )
        this.pieData = salesTeamSalesPieData(
          this.getTopTenTrade(this.items),
          this.getTheme(),
        )
      },
      clearSelection () {
        this.selectedItems = []
        this.$refs.SalesTeamGrid.selection = {}
        this.threeAxisData = salesTeamGoalsData([...this.items], this.getTheme())
        this.pieData = salesTeamSalesPieData(
          this.getTopTenTrade(this.items),
          this.getTheme(),
        )
      },
      async fetchSalesTeam () {
        try {
          const accessToken = await this.$auth.getTokenSilently()
          updateScopes(accessToken)
          const res = await fetch(`${serverUrl}/api/salesTeam`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          const data = await res.json()
          return data.salesTeam
        } catch (e) {
          return []
        }
      },
      getTopTenTrade (list) {
        var data = [...list]
        if (this.selectedItems.length > 0) {
          data = [...this.selectedItems]
        }
        if (data.length <= 10) {
          return data
        }
        const sorted = data.sort((a, b) =>
          a.TotalTradeNow < b.TotalTradeNow ? 1 : -1,
        )
        const top = sorted.slice(0, 9)
        const bottom = sorted.slice(9, sorted.length).map(a => a.TotalTradeNow)
        const rest = { SalesPerson: 'Other', TotalTradeNow: 0 }
        rest.TotalTradeNow = bottom.reduce((a, b) => a + b)
        top.push(rest)
        return top
      },
      toggleMaxArea (section) {
        var fullSize = false
        var cl = section.$el.classList
        if (cl.contains('maxArea')) {
          cl.remove('maxArea')
        } else {
          fullSize = true
          cl.add('maxArea')
        }
        return fullSize
      },
      getTheme () {
        return this.$vuetify.theme.isDark ? 'dark' : 'light'
      },
      formatNumber (number) {
        return formatNumber(number)
      },
      formatCurrency (currency) {
        return formatCurrency(currency)
      },
      formatPercentage (percentage) {
        return formatPercentage(percentage)
      },
    },
  }
</script>

<style scoped>
.v-data-table::v-deep th {
  font-size: 14px !important;
  font-weight: bold !important;
}
.maxArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 99%;
  width: 99%;
}
tr.v-data-table__selected {
  background-color: #1974d1 !important;
  color: white;
}
</style>
